"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.DEFAULT_API_4BYTES = exports.DEFAULT_ETH_NODE = void 0;
var DEFAULT_ETH_NODE = "wss://mainnet.eth.aragon.network/ws";
exports.DEFAULT_ETH_NODE = "wss://mainnet.eth.aragon.network/ws";
var DEFAULT_API_4BYTES = "https://www.4byte.directory/api/v1/signatures/";
exports.DEFAULT_API_4BYTES = "https://www.4byte.directory/api/v1/signatures/";